<template>
    <div>
        <a-config-provider :locale="antdLocale">
                <a-card>
                    <a-row>
                        <a-col :span="24">
                            <!-- 筛选条件 + 图例：宽度足够时同行排布（图例靠右），不足时图例整体换行 -->
                            <div class="header-bar">
                            <!-- 筛选条件工具栏 -->
                            <div class="toolbar">
                                <a-month-picker v-model="SelectMonthTime" @change="onChange3" :allowClear="false"
                                    style="width: 120px;" />
                                <a-tree-select v-model="orgId" style="width: 150px;" :tree-data="treeDataList"
                                    :loading="treeLoading"
                                    :replace-fields="treeReplaceFields"
                                    :dropdown-style="{ maxHeight: '400px', overflow: 'auto', width: '300px' }"
                                    :placeholder="l('please_select_organization_structure')" :dropdownMatchSelectWidth="false"
                                    allow-clear tree-default-expand-all @change="orgChange">
                                </a-tree-select>

                                <a-select showSearch style="width: 130px;text-align: left;"
                                    dropdownClassName="drop-down-Style" :dropdownMatchSelectWidth="false"
                                    :placeholder="l('please_select_status')" @change="AuditTaskStateChange" allow-clear
                                    mode="multiple">
                                    <a-select-option v-for="item in AuditTaskStateList" :key="item.itemDetailCode"
                                        :title="item.itemDetailName">
                                        {{ item.itemDetailName }}
                                    </a-select-option>
                                </a-select>
                                <a-input-search :placeholder="l('PleaseEnterAKeyword')" v-model.trim="filterText" enterButton
                                    style="width: 180px;" @search="filteronchange">
                                </a-input-search>

                                <span class="toolbar-switch">
                                    <span>{{ l('ShowAuditTemplate') }}</span>
                                    <a-switch default-checked v-model="IsShowAuditTemplate" @change="filteronchange" />
                                </span>
                                <a-button icon="export" @click="Export">{{ l('Export') }}</a-button>
                            </div>

                            <!-- 图例说明：单行紧凑排列，不换行错位 -->
                            <div class="legend-bar">
                                <span class="legend-item">
                                    <img src="../../../../../public/img/image/qj.png" />
                                    {{ l('LeaveRequested') }}
                                </span>
                                <span class="legend-item">
                                    <i class="dot dot-undone"></i>{{ l('Undone') }}
                                </span>
                                <span class="legend-item">
                                    <i class="dot dot-planned"></i>{{ l('Have_Plans') }}
                                </span>
                                <span class="legend-item">
                                    <i class="dot dot-executing"></i>{{ l('Executing') }}
                                </span>
                                <span class="legend-item">
                                    <i class="dot dot-completed"></i>{{ l('Completed') }}
                                </span>
                            </div>
                            </div>
                        </a-col>

                        <a-col :span="24" style="margin-top: 12px">
                        <a-spin :spinning="isLoading" size="large" :tip="loadingText">
                            <template slot="indicator">
                                <div class="loading-dots">
                                    <span></span><span></span><span></span>
                                </div>
                            </template>
                            <div
                                style="width:100%;height: 1px;border-top:1px solid #696969;position: absolute;z-index: 2;background-color: white;">

                            </div>
                            <div style="width:100%;overflow-y: auto;height: 100%;table-layout: fixed;z-index: 1;"
                                :style="styObj">
                                <table style="text-align: center;width: 100%;display: table;border:1px solid #696969;" id="tables">
                                    <thead>
                                        <th style="border:1px solid #696969;height: 50px;text-align: center;vertical-align:middle;width: 90px;height: 50px;position: sticky;top: 0;;background: #ffffff;table-layout: fixed;"
                                            class="body2">{{ l('audit.inspectorname') }}</th>
                                        <th v-if="IsShowAuditTemplate"
                                            style="border:1px solid #696969;height: 50px;text-align: center;vertical-align:middle;width: 140px;height: 50px;position: sticky;top: 0;background: #ffffff;"
                                            class="body1">{{ l('AuditTemplate') }}</th>
                                        <th v-for="item in month" :title="item"
                                            :style="isWeekend(item) ? { background: '#f0f0f0' } : null"
                                            style="border:1px solid #696969;vertical-align:middle;position: sticky;top: 0;background: #ffffff;"
                                            class="body">{{ item }}</th>
                                    </thead>
									<!-- <thead style="display: none;">
										<th style="border:1px solid #696969;height: 50px;text-align: center;vertical-align:middle;width: 90px;height: 50px;position: sticky;top: 0;;background: #ffffff;table-layout: fixed;"
										    class="body2">{{ l('audit.inspectorname') }}</th>
										<th v-if="IsShowAuditTemplate"
										    style="border:1px solid #696969;height: 50px;text-align: center;vertical-align:middle;width: 140px;height: 50px;position: sticky;top: 0;background: #ffffff;"
										    class="body1">{{ l('AuditTemplate') }}</th>
										<th v-for="item in month" :title="item"
										    style="border:1px solid #696969;vertical-align:middle;position: sticky;top: 0;background: #ffffff;"
										    class="body">{{ item }}</th>
									</thead> -->
																		<tbody>
										<tr v-for="(item, rowIndex) in templateList" :key="rowIndex">
										    <td style="border:1px solid #696969;height: 50px;" class="body2">
										        {{ item.inspectorName }}</td>
										   <td v-if="IsShowAuditTemplate" style="border:1px solid #696969;height: 50px" class="body1">
										        {{ item.templateName }}</td>
										    <!-- 日期区域合并为一个单元格，内部按天分列；跨天任务渲染为横跨多天的条形 -->
										    <td :colspan="month.length" class="body day-cell"
										        :style="{ height: item.laneCount > 1 ? (item.laneCount * 28 + 2) + 'px' : '50px' }"
										        style="border:1px solid #696969;">
										        <div class="task-grid" :style="gridStyle(item)">
										            <div v-for="wk in weekendCols" :key="'wk-' + wk" class="grid-weekend"
										                :style="{ gridColumn: String(wk), gridRow: '1 / -1' }"></div>
										            <template v-for="(seps, laneIdx) in item.sepLanes">
										                <div v-for="sep in seps" :key="'sep-' + laneIdx + '-' + sep" class="grid-sep"
										                    :style="{ gridColumn: String(sep), gridRow: String(laneIdx + 1) }"></div>
										            </template>
										            <div v-for="task in item.rowTasks" :key="task.id" class="task-bar"
										                :class="{ single: task.startCol === task.endCol }"
										                :style="taskBarStyle(task)" :title="taskTitle(task)"
										                @click="monthly(task.id)">
										                <img v-if="task.status === '5'" src="../../../../../public/img/image/qj.png" />
										                <template v-else>{{ task.issueCount || '' }}</template>
										            </div>
										        </div>
										    </td>
										</tr>
									</tbody>
                                    
                                </table>
                            </div>
                        </a-spin>
                    </a-col>
                </a-row>

            </a-card>
        </a-config-provider>
    </div>
</template>

<script>
import {
    AppComponentBase
} from "@/shared/component-base";
import ModalComponentBase from '../../../../shared/component-base/modal-component-base';
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import en_US from "ant-design-vue/lib/locale-provider/en_US";
import {
    AuditTaskServiceProxy,
    LayoutOrgServiceProxy
} from '../../../../shared/service-proxies';
// import CreatErrorCode from "../organization-structure/new-template/new-template";
import moment from "moment";
import {
    ModalHelper
} from '@/shared/helpers';
import monthly from "../../audit-task-view/audit-task-view.vue";
import { Dic, fileDownloadService } from "../../../../shared/utils";
import XLSX from 'xlsx';
import XLSXS from 'xlsx-style';
import FileSaver from "file-saver";

let _this;

export default {
    name: "month-view-emp",
    mixins: [ModalComponentBase],
    components: {
        // CreatErrorCode,
        monthly,
    },
    created() {
        _this = this;
        this._AuditTaskServiceProxy = new AuditTaskServiceProxy(this.$apiUrl, this.$api);
        this._LayoutOrgServiceProxy = new LayoutOrgServiceProxy(this.$apiUrl, this.$api);
    },
    async mounted() {
        this.fullData(); // 模态框必须,填充数据到data字段
        this.orgId = this.id;
        this.AuditTaskStateList = await Dic.getInstance().getDicAsync('AuditTaskState');
        this.NowMonth();
        this.getTreeData();
        window.addEventListener('resize', this.changeHeight);
        this.changeHeight();
    },
    data() {
        return {
            zh_CN,
            isEdit: false,
            isLook: false,
            isLoading: false,
            Modevalue: 1,
            hourOrDay: 1,
            selectDayTime: undefined,
            aData: undefined,
            date: undefined,
            timeRangeStartTime: undefined,
            timeRangeEndTime: undefined,
            SelectMonthTime: undefined,
            data: {
                hourOrDay: undefined,
                selectDayTime: undefined,
                SelectMonthTime: undefined,
                timeRangeStartTime: undefined,
                timeRangeEndTime: undefined,
            },
            hour: [],
            month: [],
            table: undefined,
            startTime: undefined,
            endTime: undefined,
            i: undefined,
            value: true,
            tableData: undefined,
            mmm: undefined,
            mmmm: 24,
            p: undefined,
            q: undefined,
            tabled: undefined,
            DATA: [],
            Table: undefined,
            Hour: [],
            styObj: {
                height: 0
            },
            HOUR: [],
            MONTH: {},
            MONTHDATA: undefined,

            templateList: [],

            //实测的日期列宽度模板（与表头对齐用）
            dayCols: '',

            //组织架构树独立加载状态
            treeLoading: false,

            //网格容器与表头日期区的实测对齐位置
            gridPos: null,

            treeDataList: [],
            treeReplaceFields: {
                title: 'levelNameAndName',
                key: 'id',
                value: 'id'
            },
            treeReplace: {
                title: 'name',
                key: 'id',
                value: 'id'
            },
            orgId: undefined,

            AuditTaskStateList: [],
            AuditTaskState: [],

            filterText: undefined,

            //LPA看板传参
            id: undefined,
            kanbanDate: undefined,
            IsShowAuditTemplate: true
        }
    },
    computed: {
        //antd 组件语言包跟随当前应用语言（月份选择器等控件的文案/月份显示）
        antdLocale() {
            try {
                const lang = window.abp && abp.localization && abp.localization.currentLanguage
                    ? abp.localization.currentLanguage.name : 'zh-Hans';
                return lang.indexOf('zh') === 0 ? zh_CN : en_US;
            } catch (e) {
                return zh_CN;
            }
        },
        //当前月份中的周末日期列号
        weekendCols() {
            return this.month.filter(day => this.isWeekend(day));
        },
        //加载动画文案（跟随应用语言）
        loadingText() {
            try {
                const lang = window.abp && abp.localization && abp.localization.currentLanguage
                    ? abp.localization.currentLanguage.name : 'zh-Hans';
                return lang.indexOf('zh') === 0 ? '数据加载中…' : 'Loading...';
            } catch (e) {
                return '数据加载中…';
            }
        }
    },
    methods: {
        moment,

        //判断当月某天是否周末（周六/周日）
        isWeekend(day) {
            const w = moment(this.SelectMonthTime + '-' + String(day).padStart(2, '0'), 'YYYY-MM-DD').day();
            return w === 0 || w === 6;
        },
        orgChange(key) {
            console.log(key);
            this.orgId = key;
            this.getData();
        },
        //搜索框点击事件
        filteronchange() {
            this.getData();
        },
        AuditTaskStateChange(value) {
            console.log(value);
            this.AuditTaskState = value;
            this.getData();
        },

        getTreeData() {
            //组织树用独立的加载状态，避免提前关闭表格数据区的加载动画
            this.treeLoading = true;
            this._LayoutOrgServiceProxy.getAllData(
            )
                .finally(() => {
                    this.treeLoading = false;
                })
                .then((res) => {
                    this.treeDataList = JSON.parse(JSON.stringify(res));
                })
        },
        //div高度
        changeHeight() {
            this.styObj.height = window.innerHeight - 199 + 'px';
            this.syncDayColumns();
        },
        create() {
            // this.getData();
        },
        NowMonth() {
            if (this.kanbanDate) {
                this.SelectMonthTime = this.kanbanDate;
            } else {
                this.SelectMonthTime = moment(new Date()).format('YYYY-MM');
            }

            let mm = this.SelectMonthTime.split('-'); //把2020-11变成需要传输的样子：2020和11
            this.getDaysInMonth(mm[0], mm[1]);
        },
        getData() {
            //加载中不重复请求，避免连续点击查询导致请求堆积
            if (this.isLoading) return;
            this.data.hourOrDay = this.hourOrDay;
            this.data.selectDayTime = this.selectDayTime;
            this.data.SelectMonthTime = this.SelectMonthTime;
            this.data.timeRangeStartTime = this.timeRangeStartTime;
            this.data.timeRangeEndTime = this.timeRangeEndTime;
            this.isLoading = true;
            this._AuditTaskServiceProxy.month_View({
                monthAndYear: this.SelectMonthTime,
                orgId: this.orgId,
                auditTaskStatus: this.AuditTaskState,
                isShowAuditTemplate: this.IsShowAuditTemplate,
                filterText: this.filterText
            }).finally(() => {
                this.isLoading = false;
            }).then(res => {



                // console.log(res);
				this.templateList = [];
                if (res.length <= 0) {
                    this.templateList = [];
                    return;
                }
                if (this.IsShowAuditTemplate) {
                    res.forEach(item => {
                        item.templates.forEach(itemchird => {
                            if (itemchird.auditTaskList != undefined) {
                                //摊平成带起止列的任务列表，跨天任务横跨多天合并展示
                                let built = this.buildRowTasks(itemchird.auditTaskList);
                                let ss = {
                                    inspectorName: item.inspectorName,
                                    templateName: itemchird.templateName,
                                    rowTasks: built.tasks,
                                    laneCount: built.laneCount,
                                    sepLanes: built.sepLanes,
                                }
                                this.templateList.push(ss)
                            }

                        })
                    })
                } else {
					// this.templateList = [];
                    res.forEach(item => {
                        if (item.auditTaskList != undefined) {
                            let built = this.buildRowTasks(item.auditTaskList);
                            let ss = {
                                inspectorName: item.inspectorName,
                                rowTasks: built.tasks,
                                laneCount: built.laneCount,
                                sepLanes: built.sepLanes,
                            }
                            _this.templateList.push(ss)
                        }

                    })
                }
                //数据渲染后同步日期列宽，保证表头与内容网格对齐
                this.syncDayColumns();
            });
            // for(var i=0;i<a.length;i++){
            //   for(var j=0;j<b.length;j++){
            //     if(b[j]>0){
            //       a[j]=a[j]+b[j];
            //     }
            //   }
            // }
        },
        monthly(items) {
            // console.log(items)
			if(this.IsShowAuditTemplate) {
				ModalHelper.create(monthly, {
				    id: items
				}, {
				    width: 1000
				}).subscribe(res => {
				    // console.log(res)
				})
			}
        },
        ModeChange(e) {
            if (e.target.value == 1) {
                this.value = true;
            } else if (e.target.value == 2) {
                this.value = false;
            }
            this.hourOrDay = e.target.value;
            // console.log(this.hourOrDay);
            this.getData();
        },
        onChange(date, time) {
            this.selectDayTime = time;
            this.getData();
        },
        onChange1(date, time) {
            this.startTime = time;
            this.hourOnChange();
        },
        onChange2(date, time) {
            this.endTime = time;
            this.hourOnChange();
        },
        onChange3(date, time) {
            this.SelectMonthTime = time;
            let mm = this.SelectMonthTime.split('-'); //把2020-11变成需要传输的样子：2020和11
            this.getDaysInMonth(mm[0], mm[1]);
        },

        StatusColor(status) {
            if (status == "4") {
                return "red";
            }
            if (status == "1") {
                return "#6ec5d2";
            }
            if (status == "3" || status == "6") {
                return "white";
            }
            if (status == "2") {
                return "#6ec5d2";
            }
        },
        //把"每天的任务"摊平为带起止列的任务列表；同一任务会在周期内每天都出现，这里按 id 去重
        buildRowTasks(auditTaskList) {
            const days = this.month.length;
            const seen = {};
            const tasks = [];
            (auditTaskList || []).forEach((cell, idx) => {
                (cell.tasks || []).forEach(t => {
                    if (!t || !t.id || seen[t.id]) return;
                    let startCol = this.dayIndexOf(t.planStartDate) || idx + 1;
                    let endCol = this.dayIndexOf(t.planEndDate) || startCol;
                    if (endCol < startCol) {
                        const tmp = startCol;
                        startCol = endCol;
                        endCol = tmp;
                    }
                    //跨月任务截断到当前月份的可视范围
                    startCol = Math.max(1, Math.min(startCol, days));
                    endCol = Math.max(1, Math.min(endCol, days));
                    seen[t.id] = true;
                    tasks.push({
                        id: t.id,
                        status: t.status,
                        issueCount: t.issueCount,
                        planStartDate: t.planStartDate,
                        planEndDate: t.planEndDate,
                        startCol: startCol,
                        endCol: endCol,
                    });
                });
            });
            //时间重叠的任务分配到不同车道，避免条形互相压盖
            tasks.sort((a, b) => a.startCol - b.startCol || b.endCol - a.endCol || a.id - b.id);
            const laneEnds = [];
            tasks.forEach(task => {
                let track = laneEnds.findIndex(end => end < task.startCol);
                if (track < 0) {
                    laneEnds.push(task.endCol);
                    track = laneEnds.length - 1;
                } else {
                    laneEnds[track] = task.endCol;
                }
                task.track = track;
            });
            //按车道生成分隔线：被任务条跨越的列边界不画线，让跨天任务看起来是一个整体
            const sepLanes = [];
            for (let lane = 0; lane < Math.max(1, laneEnds.length); lane++) {
                const barsInLane = tasks.filter(t => t.track === lane);
                const seps = [];
                for (let b = 1; b < days; b++) {
                    if (!barsInLane.some(t => t.startCol <= b && b < t.endCol)) {
                        seps.push(b);
                    }
                }
                sepLanes.push(seps);
            }
            return { tasks: tasks, laneCount: Math.max(1, laneEnds.length), sepLanes: sepLanes };
        },
        //日期字符串(yyyy-MM-dd)转为当月列号(1=当月1号)；早于当月返回-1、晚于当月返回32，配合列数截断使用
        dayIndexOf(dateStr) {
            if (!dateStr) return 0;
            const p = dateStr.split('-');
            if (p.length < 3) return 0;
            const y = parseInt(p[0], 10);
            const m = parseInt(p[1], 10);
            const d = parseInt(p[2], 10);
            if (isNaN(y) || isNaN(m) || isNaN(d)) return 0;
            const sel = (this.SelectMonthTime || '').split('-');
            const sy = parseInt(sel[0], 10);
            const sm = parseInt(sel[1], 10);
            if (y < sy || (y === sy && m < sm)) return -1;
            if (y > sy || (y === sy && m > sm)) return 32;
            return d;
        },
        gridStyle(item) {
            const lanes = item.laneCount || 1;
            //列宽优先用实测的表头日期列宽度（表格按整像素取整，1fr 亚像素会逐列累积偏移）
            const style = {
                gridTemplateColumns: this.dayCols || 'repeat(' + this.month.length + ', 1fr)',
                gridTemplateRows: 'repeat(' + lanes + ', 1fr)',
            };
            if (this.gridPos) {
                style.left = this.gridPos.left;
                style.width = this.gridPos.width;
                style.right = 'auto';
            }
            return style;
        },
        //实测表头日期列宽度并同步到内容网格，保证表头与内容列严格对齐
        syncDayColumns() {
            this.$nextTick(() => {
                const ths = document.querySelectorAll('#tables thead th.body');
                const td = document.querySelector('#tables tbody td.day-cell');
                if (!ths.length || !td || ths.length !== this.month.length) {
                    this.dayCols = '';
                    this.gridPos = null;
                    return;
                }
                const thRects = Array.from(ths).map(th => th.getBoundingClientRect());
                const tdRect = td.getBoundingClientRect();
                //网格与表头日期区像素级重合（消除单元格边框塌陷造成的常数偏移）
                const left = thRects[0].left - tdRect.left;
                const width = thRects[ths.length - 1].right - thRects[0].left;
                if (width <= 0) {
                    this.dayCols = '';
                    this.gridPos = null;
                    return;
                }
                this.gridPos = { left: left.toFixed(2) + 'px', width: width.toFixed(2) + 'px' };
                this.dayCols = thRects.map(r => r.width.toFixed(2) + 'px').join(' ');
            });
        },
        //跨天任务渲染为横跨起止列的条形；单天任务保持原有的圆点/方块样式
        taskBarStyle(task) {
            const single = task.startCol === task.endCol;
            const style = {
                gridColumn: task.startCol + ' / ' + (task.endCol + 1),
                gridRow: String(task.track + 1),
            };
            if (task.status === '5') {
                style.backgroundColor = '#ffffff';
                style.border = '1px dashed #d9d9d9';
                style.borderRadius = single ? '0' : '999px';
                return style;
            }
            style.backgroundColor = this.StatusColor(task.status);
            style.borderRadius = single
                ? (task.status === '1' ? '0' : '999px')
                : (task.status === '1' ? '4px' : '999px');
            style.border = this.Border(task.status);
            style.color = this.Color(task.status);
            style.lineHeight = (task.status === '3' || task.status === '6') ? '15px' : '21px';
            return style;
        },
        taskTitle(task) {
            if (!task.planStartDate || !task.planEndDate) return '';
            return task.startCol === task.endCol ? task.planStartDate : (task.planStartDate + ' ~ ' + task.planEndDate);
        },
        Border(status) {
            if (status === "3" || status == "6") {
                return "3px green solid";
            }
        },
        Color(status) {
            if (status === "3" || status == "6") {
                return "#000000";
            } else {
                return "#ffffff";
            }
        },

        hourOnChange() {
            if (this.startTime != undefined && this.endTime != undefined) {
                this.timeRangeStartTime = this.startTime + ":00:00";
                this.timeRangeEndTime = this.endTime + ":00:00";
                let s = parseInt(this.startTime);
                let e = parseInt(this.endTime);
                this.mmmm = e - s;
                this.hour = [];
                for (let g = s; g < e; g++) {
                    this.i = g;
                    this.hour.push(this.i);
                }
                // console.log(this.hour)
                if (this.timeRangeStartTime == ":00:00" || this.timeRangeEndTime == ":00:00") {
                    this.timeRangeStartTime = undefined;
                    this.timeRangeEndTime = undefined;
                    let i = 24;
                    this.mmmm = i;
                    this.hour = [];
                    for (let a = 0; a < i; a++) {
                        this.hour.push(a);
                    }
                }
                this.getData();
            } else {

            }
        },
        getDaysInMonth(year, month) {
            this.month = [];
            let temp = new Date(year, month, 0);
            let mm = temp.getDate(); //这里mm就是天数啦
            this.mmm = mm;
            for (let m = 1; m < mm + 1; m++) {
                this.month.push(m);
            }
            console.log(this.month)
            this.getData();
        },
		
		Export() {
			try {
			    if (!this.templateList.length) {
			        this.$message.error('暂无可导出的数据');
			        return;
			    }

			    // 1. 构建表头：审核员 + (模板) + 每天一列
			    const header = [this.l('audit.inspectorname')];
			    if (this.IsShowAuditTemplate) {
			        header.push(this.l('AuditTemplate'));
			    }
			    this.month.forEach(day => {
			        header.push(day + '日');
			    });
			    const dayStart = this.IsShowAuditTemplate ? 2 : 1; //日期列起始下标

			    // 2. 按车道生成数据行；跨天任务在起止列之间合并单元格
			    const symbolMap = { 1: '■', 2: '●', 3: '○', 4: '×', 5: '▲', 6: '○' }; //与页面图形对应的状态符号
			    const merges = [];
			    const rows = [header];
			    this.templateList.forEach(item => {
			        const lanes = item.laneCount || 1;
			        for (let lane = 0; lane < lanes; lane++) {
			            const row = new Array(header.length).fill('');
			            if (lane === 0) {
			                row[0] = item.inspectorName || '';
			                if (this.IsShowAuditTemplate) {
			                    row[1] = item.templateName || '';
			                }
			            }
			            (item.rowTasks || []).filter(task => task.track === lane).forEach(task => {
			                row[dayStart + task.startCol - 1] = (symbolMap[task.status] || '') + (task.issueCount || '');
			                if (task.endCol > task.startCol) {
			                    merges.push({
			                        s: { r: rows.length, c: dayStart + task.startCol - 1 },
			                        e: { r: rows.length, c: dayStart + task.endCol - 1 }
			                    });
			                }
			            });
			            rows.push(row);
			        }
			    });

			    // 3. 生成工作表并确保合并区域内的空单元格存在（便于统一加边框）
			    const ws = XLSX.utils.aoa_to_sheet(rows);
			    for (let r = 0; r < rows.length; r++) {
			        for (let c = 0; c < header.length; c++) {
			            const addr = XLSX.utils.encode_cell({ r: r, c: c });
			            if (!ws[addr]) {
			                ws[addr] = { t: 's', v: '' };
			            }
			        }
			    }
			    if (merges.length) {
			        ws['!merges'] = merges;
			    }
			    this.setExlStyle(ws); //应用原有样式（边框、居中、加粗等）

			    // 4. 创建工作簿并添加工作表
			    const wb = XLSX.utils.book_new();
			    XLSX.utils.book_append_sheet(wb, ws, '月视图');

			    // 5. 用 xlsx-style 写入并导出文件
			    const wbout = XLSXS.write(wb, {
			        type: 'buffer',
			        bookType: 'xlsx'
			    });

			    FileSaver.saveAs(
			        new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
			        `员工月视图_${this.SelectMonthTime}.xlsx`
			    );

			} catch (e) {
			    console.error('导出失败：', e);
			    this.$message.error(`导出失败：${e.message}`);
			}
		},

		setExlStyle(data) {
			if (!data) return data;
		    let borderAll = {
		        //单元格外侧框线
		        top: {
					style: "thin",
		        },
		        bottom: {
					style: "thin",
		        },
		        left: {
					style: "thin",
		        },
		        right: {
					style: "thin",
		        },
		    };
		    data["!cols"] = [];
		    for (let key in data) {
				if (data[key] instanceof Object) {
					data[key].s = {
						border: borderAll,
						alignment: {
							horizontal: "center", //水平居中对齐
							vertical: "center",
						},
						font: {
							sz: 11,
						},
						bold: true,
						numFmt: 0,
					};
					data["!cols"].push({ wpx: 115 });
				}
		    }
		    return data;
		},
		
		addRangeBorder(range, ws) {
			console.log(range)
		    // s:起始位置，e:结束位置
		    let arr =["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"];
		    range.forEach((item) => {
				let startRowNumber = Number(item.s.r), startColumnNumber = Number(item.s.c), endColumnNumber = Number(item.e.c), endRowNumber = Number(item.e.r);
		        //合并单元格时会丢失边框样式，例如A1->A4 此时内容在A1 而range内获取到的是从0开始的，所以开始行数要+2
		        for (let i = startColumnNumber; i <= endColumnNumber; i++) {
		            for(let j = startRowNumber+2 ;j<= endRowNumber+1 ; j++) {
		                console.log(arr[i] + j)
		                ws[arr[i] + j] = {
		                    s: {
								border: {
									top: { style: "thin" },
									left: { style: "thin" },
									bottom: { style: "thin" },
		                            right: { style: "thin" },
		                        },
		                    },
		                };
		            }
		
		        }
		    });
		    console.log(ws);
		    return ws;
		}
    }
}
</script>

<style scoped>
.body {
    min-width: 30px;
    min-height: 50px;
}

.body1 {
    min-width: 100px;
    min-height: 50px;
}

.body2 {
    min-width: 70px;
    min-height: 50px;
}

table {
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
}

th.body2,
td.body2 {
    position: sticky;
    left: 0;
    z-index: 2;
    background: #ffffff;
}

th.body1 {
    position: sticky;
    left: 90px;
    z-index: 2;
    background: #ffffff;
}

td.body1 {
    position: sticky;
    left: 90px;
    z-index: 1;
    background: #ffffff;
}

.day-cell {
    padding: 0;
    position: relative;
}

.task-grid {
    /*绝对定位填满单元格，使分隔线首尾连接到行边框线*/
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: grid;
    align-items: center;
}

/*周末列浅灰背景，贯穿整行车道，条形与分隔线浮在其上层*/
.grid-weekend {
    align-self: stretch;
    background-color: #f0f0f0;
}

/*按天分列的分隔线，画在每列右缘；置于周末底色与条形的上层，保证线框不被色块盖住*/
.grid-sep {
    position: relative;
    z-index: 1;
    justify-self: end;
    align-self: stretch;
    width: 1px;
    background-color: #696969;
}

.task-bar {
    position: relative;
    z-index: 1;
    height: 23px;
    margin: 1px 2px;
    box-sizing: border-box;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
    overflow: hidden;
    cursor: pointer;
    align-self: center;
}

/*单天任务保持原有的圆点/方块观感，不横向拉伸*/
.task-bar.single {
    justify-self: center;
    width: 23px;
}

.task-bar img {
    height: 23px;
    max-width: 100%;
}

/*筛选条件 + 图例容器：宽度足够时同行，图例靠右；不足时图例换行*/
.header-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
}

/*筛选条件工具栏：单行弹性排列，宽度不足时整体换行*/
.toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 10px;
    flex: 1 1 640px;
}

.toolbar-switch {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
    margin: 0 2px;
}

/*图例：宽度足够时靠右与筛选条件并排，不足时整体换行*/
.legend-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px 20px;
    margin-left: auto;
    padding: 7px 12px;
    background: #fafafa;
    border-radius: 4px;
}

.legend-item {
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
    color: rgba(0, 0, 0, 0.65);
}

.legend-item img {
    height: 16px;
    margin-right: 6px;
}

.dot {
    display: inline-block;
    width: 14px;
    height: 14px;
    margin-right: 6px;
    flex: none;
}

.dot-undone {
    border-radius: 50%;
    background-color: red;
}

.dot-planned {
    border-radius: 2px;
    background-color: #6ec5d2;
}

.dot-executing {
    border-radius: 50%;
    background-color: #6ec5d2;
}

.dot-completed {
    border-radius: 50%;
    background-color: #ffffff;
    border: 2px solid green;
    box-sizing: border-box;
}

/*数据加载动画：三个跳动圆点*/
.loading-dots {
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.loading-dots span {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #1890ff;
    animation: loading-dot-bounce 1s infinite ease-in-out;
}

.loading-dots span:nth-child(2) {
    animation-delay: 0.15s;
}

.loading-dots span:nth-child(3) {
    animation-delay: 0.3s;
}

@keyframes loading-dot-bounce {
    0%, 80%, 100% {
        transform: scale(0.6);
        opacity: 0.4;
    }
    40% {
        transform: scale(1);
        opacity: 1;
    }
}
</style>